export default __webpack_public_path__ + "static/CharterITCW05-BoldItalic-5458a3029df5b4277143d0caa2289940.woff2";